<li tabindex="18">
    <ng-select
        class="nlr-ng-select nlr-ng-select-ribbon"
        [searchable]="false"
        [clearable]="false"
        name="mapMode"
        id="mapMode"
        [items]="mapModeList"
        bindLabel="label"
        [ngModel]="mapMode"
        (change)="onSelectMapMode($event)">
        <ng-template
            ng-option-tmp
            let-item="item">
            <div [title]="item.label">
                {{item.label}}
            </div>
        </ng-template>
    </ng-select>
</li>
